import React, { useState } from 'react';
import { Tooltip, Fab } from "@mui/material";
import Grid from '@mui/material/Grid2';
import { 
  Campaign,
  Character,
  CharacterOptions,
} from "@dndModels";

import API from "@dndUtilities/system_api";
import DandDCharacterUtilities from "@dndUtilities/char_utilities";
// import DataUtilities from '../../utilities/common_utilities';

import ToggleButtonBox from "@components/input/buttons/ToggleButtonBox";
import FloatMenu from "@components/input/menus/FloatMenu";

import CharacterViewInventory from "@dndComponents/character/inventory/CharacterViewInventory";
import CharacterFeatures from "@dndComponents/character/features/CharacterFeatures";
import CharacterSpells from "@dndComponents/character/spells_and_abilities/CharacterSpells";
import CharacterProficiencies from "@dndComponents/character/misc/CharacterProficiencies";
import CharacterActions from "@dndComponents/character/spells_and_abilities/CharacterActions";
import CharacterAbilityScores from "@dndComponents/character/ability_scores/CharacterAbilityScores";
import CharacterSavingThrows from "@dndComponents/character/saves/CharacterSavingThrows";
import CharacterSenses from "@dndComponents/character/misc/CharacterSenses";
import CharacterSkills from "@dndComponents/character/skills/CharacterSkills";
import CharacterOptionsInput from "@dndComponents/character/misc/CharacterOptionsInput";
import CharacterBar3 from "@dndComponents/character/bar3/CharacterBar3";
import CharacterCampaignInfo from "@dndComponents/character/misc/CharacterCampaignInfo";
import ModalOrDrawer from "@components/display/ModalOrDrawer";
import CharacterDefenses from "@dndComponents/character/defenses/CharacterDefenses";
import CharacterConditions from "@dndComponents/character/conditions/CharacterConditions";
import CharacterMinions from "@dndComponents/character/minions/CharacterMinions";
import CharacterPassives from "@dndComponents/character/spells_and_abilities/CharacterPassives";
import CharacterLanguages from "@dndComponents/character/misc/CharacterLanguages";

interface Props {
  character: Character; 
  // campaign?: Campaign;
  shared: boolean;
}

const api = API.getInstance();
const char_util = DandDCharacterUtilities.getInstance();
// const common_util = DataUtilities.getInstance();

export default function CharacterMainDetails({ 
  character, 
  // campaign,
  shared,
}: Props) {
  const [menu_open, setMenuOpen] = useState("");
  const [the_view, setView2] = useState(character.default_view);
  const [default_view, setDefaultView] = useState(character.default_view);

  const char_interface = character.char_interface;

  const setView = (v: string) => {
    setView2(v);
  }

  const renderExtras = () => {
    const campaign = character.campaign;
    return (
      <ModalOrDrawer
        open={ menu_open === "campaign" } 
        onClose={() => {
          setMenuOpen("");
        }}>
        { campaign && menu_open === "campaign" &&
          <CharacterCampaignInfo
            character={character}
            campaign={campaign}
          />
        }
      </ModalOrDrawer>
    );
  }

  const renderSelectedView = () => {
    // console.log("renderSelectedView");
    let return_me: any = <Grid>{the_view} Coming Soon</Grid>;
    const width = window.innerWidth;
    // console.log(the_view);
    const menu_options = width < 1024 ? ["Main","Actions","Spells","Inventory","Features & Traits","Options"] : ["Actions","Spells","Inventory","Features & Traits","Options"];
    switch (the_view) {
      case "Main":
        if (width < 768) {
          return_me = (
            <>
              <Grid size={12}
                className="bg_black_transp">
                <FloatMenu 
                  options={menu_options}
                  selected={the_view}
                  onSelect={setView}
                />
              </Grid>
              <Grid size={12}>
                <CharacterAbilityScores 
                  character={character}
                  char_interface={char_interface}
                  shared={shared}
                />
              </Grid>
              <Grid size={12}>
                <CharacterSavingThrows 
                  character={character}
                  char_interface={char_interface}
                  shared={shared}
                />
              </Grid>
              <Grid size={12}>
                <CharacterSenses
                  character={character} 
                  char_interface={char_interface}
                  disabled={shared}
                />
              </Grid>
              <Grid size={12}>
                <CharacterProficiencies 
                  character={character}
                  char_interface={char_interface}
                  disabled={shared}
                />
              </Grid>
              <Grid size={12}>
                <CharacterLanguages 
                  character={character}
                  char_interface={char_interface}
                  disabled={shared}
                />
              </Grid>
              <Grid size={12}>
                <CharacterSkills 
                  character={character} 
                  char_interface={char_interface}
                  shared={shared}
                />
              </Grid>
              <Grid size={12}>
                <CharacterDefenses 
                  character={character} 
                  char_interface={char_interface}
                  shared={shared}
                />
              </Grid>
              <Grid size={12}>
                <CharacterConditions 
                  char={character} 
                  char_interface={char_interface}
                  shared={shared}
                />
              </Grid>
              <Grid size={12}>
                <CharacterMinions 
                  character={character} 
                  char_interface={char_interface}
                  shared={shared}
                />
              </Grid>
              <Grid size={12}>
                <CharacterPassives
                  character={character}
                  char_interface={char_interface}
                  shared={shared}
                />
              </Grid>
            </>
          );
        } else if (width < 1024) {
          return_me = (
            <>
              <Grid size={12}
                className="bg_black_transp">
                <FloatMenu 
                  options={menu_options}
                  selected={the_view}
                  onSelect={setView}
                />
              </Grid>
              <Grid size={12}>
                <CharacterAbilityScores 
                  character={character}
                  char_interface={char_interface}
                  shared={shared}
                  horizontal
                />
              </Grid>
              <Grid size={6}>
                <Grid container spacing={0} direction="row">
                  <Grid size={12}>
                    <CharacterSavingThrows 
                      character={character}
                      char_interface={char_interface}
                      shared={shared}
                      vertical
                    />
                  </Grid>
                  <Grid size={12}>
                    <CharacterSenses
                      character={character} 
                      char_interface={char_interface}
                      disabled={shared}
                    />
                  </Grid>
                  <Grid size={12}>
                    <CharacterProficiencies 
                      character={character}
                      char_interface={char_interface}
                      disabled={shared}
                    />
                  </Grid>
                  <Grid size={12}>
                    <CharacterLanguages 
                      character={character}
                      char_interface={char_interface}
                      disabled={shared}
                    />
                  </Grid>
                  <Grid size={12}>
                    <CharacterDefenses 
                      character={character} 
                      char_interface={char_interface}
                      shared={shared}
                    />
                  </Grid>
                  <Grid size={12}>
                    <CharacterConditions 
                      char={character} 
                      char_interface={char_interface}
                      shared={shared}
                    />
                  </Grid>
                  <Grid size={12}>
                    <CharacterMinions 
                      character={character} 
                      char_interface={char_interface}
                      shared={shared}
                    />
                  </Grid>
                </Grid>
              </Grid>
              <Grid size={6}>
                <Grid container spacing={0} direction="row">
                  <Grid size={12}>
                    <CharacterSkills 
                      character={character} 
                      char_interface={char_interface}
                      shared={shared}
                    />
                  </Grid>
                </Grid>
              </Grid>
              <Grid size={12}>
                <CharacterPassives
                  character={character}
                  char_interface={char_interface}
                  shared={shared}
                />
              </Grid>
            </>
          );
        } else {
          return_me = 
            <>
              <Grid size={12}
                className="bg_black_transp">
                <FloatMenu 
                  options={menu_options}
                  selected={the_view}
                  onSelect={setView}
                />
              </Grid>
              <Grid size={12}>
                <CharacterActions 
                  character={character}
                  char_interface={char_interface}
                  shared={shared}
                />
              </Grid>
            </>;
        }
      break;
      case "Inventory":
        return_me = 
          <>
            <Grid size={12}
              className="bg_black_transp">
              <FloatMenu 
                options={menu_options}
                selected={the_view}
                onSelect={setView}
              />
            </Grid>
            <Grid size={12}>
              <CharacterViewInventory 
                character={character}
                disabled={shared}
                shared={shared}
              />
            </Grid>
          </>;
      break;
      case "Features & Traits":
        return_me = 
          <>
            <Grid
              className="bg_black_transp"
              size={{
                xs: 12
              }}>
              <FloatMenu 
                options={menu_options}
                selected={the_view}
                onSelect={setView}
              />
            </Grid>
            <Grid
              size={{
                xs: 12
              }}>
              <CharacterFeatures 
                character={character}
              />
            </Grid>
          </>;
      break;
      case "Spells":
        return_me = 
          <>
            <Grid
              className="bg_black_transp"
              size={{
                xs: 12
              }}>
              <FloatMenu 
                options={menu_options}
                selected={the_view}
                onSelect={setView}
              />
            </Grid>
            <Grid
              size={{
                xs: 12
              }}>
              <CharacterSpells 
                character={character}
                char_interface={char_interface}
                // campaign={campaign}
                shared={shared}
              />
            </Grid>
          </>;
      break;
      case "Actions":
        return_me = 
          <>
            <Grid
              className="bg_black_transp"
              size={{
                xs: 12
              }}>
              <FloatMenu 
                options={menu_options}
                selected={the_view}
                onSelect={setView}
              />
            </Grid>
            <Grid
              size={{
                xs: 12
              }}>
              <CharacterActions 
                character={character}
                char_interface={char_interface}
                shared={shared}
              />
            </Grid>
          </>;
      break;
      case "Options":
        return_me = 
          <>
            <Grid size={12} className="bg_black_transp">
              <FloatMenu 
                options={menu_options}
                selected={the_view}
                onSelect={setView}
              />
            </Grid>
            <Grid size={12}>
              <CharacterOptionsInput 
                obj={character}
                disabled={shared}
                onChange={ async (character_options: CharacterOptions) => {
                  // debugger;
                  character.character_options = character_options.clone();
                  
                  api.removeCharacterCookies(character._id);
                  character.changed();
                  character.last_saved = character.last_changed;
                  character.cookie_saved = character.last_changed;
                  char_util.enforceOptions(character);
                  await api.updateCharacter(character, ["all"], true);
                  char_util.emptyHash();
                  character.subscription_holder.reload();
                }}
              />
            </Grid>
          </>;
      break;
    }
    if (width >= 1024) {
      return_me = (
        <>
          <Grid size={6}>
            <Grid container spacing={0} direction="row">
              <Grid size={12}>
                <CharacterAbilityScores 
                  character={character}
                  char_interface={char_interface}
                  shared={shared}
                  horizontal
                />
              </Grid>
              <Grid size={12}
                container spacing={0} direction="row">
                <Grid size={6}>
                  <Grid container spacing={0} direction="row">
                    <Grid size={12}>
                      <CharacterSavingThrows 
                        character={character}
                        char_interface={char_interface}
                        shared={shared}
                        vertical
                      />
                    </Grid>
                    <Grid size={12}>
                      <CharacterSenses
                        character={character} 
                        char_interface={char_interface}
                        disabled={shared}
                      />
                    </Grid>
                    <Grid size={12}>
                      <CharacterProficiencies 
                        character={character}
                        char_interface={char_interface}
                        disabled={shared}
                      />
                    </Grid>
                    <Grid size={12}>
                      <CharacterLanguages 
                        character={character}
                        char_interface={char_interface}
                        disabled={shared}
                      />
                    </Grid>
                    <Grid size={12}>
                      <CharacterDefenses 
                        character={character} 
                        char_interface={char_interface}
                        shared={shared}
                      />
                    </Grid>
                    <Grid size={12}>
                      <CharacterConditions 
                        char={character} 
                        char_interface={char_interface}
                        shared={shared}
                      />
                    </Grid>
                    <Grid size={12}>
                      <CharacterMinions 
                        character={character} 
                        char_interface={char_interface}
                        shared={shared}
                      />
                    </Grid>
                  </Grid>
                </Grid>
                <Grid size={6}>
                  <Grid container spacing={0} direction="row">
                    <Grid size={12}>
                      <CharacterSkills 
                        character={character} 
                        char_interface={char_interface}
                        shared={shared}
                      />
                    </Grid>
                  </Grid>
                </Grid>
                <Grid size={12}>
                  <CharacterPassives
                    character={character}
                    char_interface={char_interface}
                    shared={shared}
                  />
                </Grid>
              </Grid>
            </Grid>
          </Grid>
          <Grid size={6}>
            <Grid container spacing={0} direction="row">
              { return_me }
            </Grid>
          </Grid>
        </>
      );
    }
    return return_me;
  }

  // console.log("Rendering Char Main Details");
  // console.log(menu_open);
  // console.log(the_view);
  // console.log(default_view);
  return (
    <Grid container spacing={0} direction="row" style={{ lineHeight: "1.5" }}>
      <Grid size={12}
        style={{ 
          borderTop: "1px solid",
          borderBottom: "1px solid" 
        }}>
        <CharacterBar3
          char={character}
          char_interface={char_interface}
          shared={shared}
        />
      </Grid>
      <Grid size={12}
        container spacing={0} direction="row"
        className="padded">
        <Grid size={12}
          container spacing={0} direction="row">
          <Grid size={1}>
            <Tooltip title={ default_view === the_view ? "This is your default view" : `Make Default View` }>
              <Fab size="small" color={ default_view !== the_view ? "primary" : undefined } style={{ marginLeft: "8px", backgroundColor: (default_view === the_view ? "gray" : undefined)}}
                onClick={ () => {
                  if (default_view !== the_view) {
                    character.default_view = the_view;
                    character.changed();
                    setDefaultView(the_view);
                  }
                }}>
                  <svg className="MuiSvgIcon-root MuiSvgIcon-fontSizeMedium  css-w2bhrx" focusable="false" aria-hidden="true" viewBox="0 0 24 24" data-testid="PushPinIcon" aria-label="fontSize medium"><path fillRule="evenodd" d="M16 9V4h1c.55 0 1-.45 1-1s-.45-1-1-1H7c-.55 0-1 .45-1 1s.45 1 1 1h1v5c0 1.66-1.34 3-3 3v2h5.97v7l1 1 1-1v-7H19v-2c-1.66 0-3-1.34-3-3z"></path></svg>
              </Fab>
            </Tooltip>
          </Grid>
          <Grid size={11}>
            { character.campaign && 
              <div className="bg_black_transp">
                <ToggleButtonBox
                  name={character.campaign.name}
                  value={false} 
                  onToggle={() => {
                    setMenuOpen("campaign");
                  }} 
                />
              </div>
            }
          </Grid>
        </Grid>
        { renderSelectedView() }
        <Grid size={12} style={{ height: "60px" }}>&nbsp;</Grid>
      </Grid>
      { renderExtras() }
    </Grid>
  );
}
